import React from 'react';
import AirlineDetailPage from '../components/AirlineDetailPage';
import { TAP_PORTUGAL } from '../data/airlinesData';

export default function TapPortugalPage() {
  return <AirlineDetailPage airline={TAP_PORTUGAL} />;
}
